import { anonymousRegisterStringForStore, registrationCodeStringForStore } from '../../constants/storageKeys';
import { decodeToken } from '../../utils/jwt/jwt-helper';
import { remove, saveString } from '../../utils/storage';
import { useInitAnalytics } from '../useInitAnalytics';
import { useRegionAndTimeZoneMutation } from '../useRegionAndTimeZoneMutation';
import { useStores } from '../useStores';


export const useManageToken = (redirectCb: () => void = () => {return;}, redirectTowardsReckoning = false, initOneSignal = false) => {

  const rootStore = useStores();
  const {setRegionAndTimezone} = useRegionAndTimeZoneMutation();
  const {initAnalyticsForRegister} = useInitAnalytics();
  const manageToken = async (token: string, anonymous = false): Promise<void> => {
    const decodedData = decodeToken(token);
    await saveString('token', token);
    initAnalyticsForRegister(decodedData, redirectTowardsReckoning, initOneSignal);
    const lang = decodedData.preferredLanguage ? decodedData.preferredLanguage : rootStore?.language?.name?.key;
    const userData = {
      user: {
        _id: decodedData._id,
        firstName: decodedData.firstName,
        email: decodedData.email,
        name: decodedData.name,
        language: lang,
        tokenExpires: decodedData.tokenExpires,
        company: decodedData.company,
        companyName: decodedData?.companyName,
        onboardingDone: decodedData?.onboardingSurveyMade,
        oneSignalExternalIdToken: decodedData?.oneSignalExternalIdToken,
        oneSignalEmailToken: decodedData?.oneSignalEmailToken,
        role: decodedData?.role,
      },
      activationCode: decodedData.activationCode,
    };
    setRegionAndTimezone();
    rootStore?.register(userData, redirectCb);
    if(!anonymous){
      remove(registrationCodeStringForStore);
      remove(anonymousRegisterStringForStore);
    }


  };


  return manageToken;
};